import {
  any,
  complement,
  compose,
  filter,
  isNil,
  map,
  prop,
  propEq,
  propOr
} from 'ramda';

const isCommissioned = compose(complement(isNil), prop('commission'));

const filterByCommission = (selectedCommission) => (prices) =>
  any(isCommissioned, prices)
    ? filter(propEq('commission', selectedCommission), prices)
    : prices;

const pickPrices = (selectedCommission) => (item, key) =>
  filterByCommission(selectedCommission)(propOr([], key, item));

const filterPricingsByCommission = (selectedCommission) =>
  map((pricing) => ({
    ...pricing,
    prices: pickPrices(selectedCommission)(pricing, 'prices'),
    totalPrices: pickPrices(selectedCommission)(pricing, 'totalPrices'),
    options: map(
      (option) => ({
        ...option,
        prices: pickPrices(selectedCommission)(option, 'prices')
      }),
      propOr([], 'options', pricing)
    )
  }));

export default filterPricingsByCommission;
